import DefaultInstituteImage from '../assets/images/default/institute.svg';
import DefaultScholarshipImage from '../assets/images/default/scholarship.svg';
import DefaultNewsImage from '../assets/images/default/news.svg';

type DefaultImageRequiredModule = 'institute' | 'scholarship' | 'news';
export const getDefaultImageSrc = (module: DefaultImageRequiredModule): string => {
  switch (module) {
    case 'institute':
      return DefaultInstituteImage;
    case 'scholarship':
      return DefaultScholarshipImage;
    case 'news':
      return DefaultNewsImage;
  }
};

export const loadDefaultImageOnError = (
  module: DefaultImageRequiredModule,
  event: React.SyntheticEvent<HTMLImageElement>
): void => {
  const target = event.currentTarget;
  const defaultImageSrc = getDefaultImageSrc(module);
  if (target.src !== defaultImageSrc) {
    target.src = defaultImageSrc;
  }
};
